<template>
  <div class="login">
    <div class="cover"></div>
    <div class="modal">
      <div v-if="reauth">
        <h1>Sorry!</h1>
        <p>It looks like we need to re-authenticate you with Yahoo to perform this action. You'll be redirected back here&nbsp;afterwards.</p>
      </div>
      <div v-else>
        <h1>Log In</h1>
        <p>We authenticate users securely through Yahoo.com. You'll be redirected back here&nbsp;afterwards.</p>
      </div>
      <div class="buttons">
        <button @click="authenticate()" class="dark hollow">Continue to Yahoo</button>
        <button @click="cancel()" class="link cancel">Cancel</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'login-confirm',
  data () {
    return {}
  },
  created: function () {},
  computed: {
    reauth: function () {
      return this.$store.getters.reauthRequired
    }
  },
  methods: {
    authenticate: function () {
      this.$store.dispatch('authenticate')
    },
    cancel: function () {
      this.$store.dispatch('cancelLogin')
    }
  }
}
</script>
<style src="./login-confirm.styl" lang="stylus" scoped></style>
